<template>
  <div>
    <transition>
      <div class="popup_addr" v-show="isPopup">
        <div class="popup_header">
          <div class="visually-hidden" aria-live="assertive" ref="searchResultMessage"></div>
          <h4>{{ popup_title }} 입력</h4><a href="#" @click="addressPopupCloseInDialog">닫기</a>
        </div>
        <div class="form-group popup_result_top">
          <div class="btn_both btn_both_triplet" style="margin-bottom: 10px;">
            <button class="btn_common" :class="addr_type === 's_addr' ? 'btn_triplet' : 'btn_twin'" ref="current_loc_sch" @click="getCurrentGeolocation"
                    v-if="addr_type=='s_addr'">현재 위치
            </button>
            <button class="btn_common" ref="history_loc_sch"
                    :class="[addr_type === 's_addr' ? 'btn_triplet' : (addr_type === 'e_addr' ? 'btn_twin' : 'display-none')]" @click="getAddrHistory">
              최근 {{ popup_title }}
            </button>
<!--          TODO 최우석 대리님께 주소록을 받아서 DB등록한 후 연동할 것 -->
              <button class="btn_common" ref="history_loc_sch" :class="[addr_type === 's_addr' ? 'btn_triplet' : (addr_type === 'e_addr' ? 'btn_twin' : '')]" @click="getAddrHistory">주소록</button>
          </div>
          <input type="text" class="form-control" ref="keyword" :title="popup_title+' 주소 검색'"
                 v-bind:placeholder="popup_title+' 주소 검색'" v-model.trim="keyword"
                 @keyup.enter="addressSearchShow"/>
          <button class="btn_common" @click="addressSearchShow">주소 검색</button>
        </div>
        <div class="popup_result" v-if="view_type=='search'">
          <h5>조회 결과</h5>
          <a class="result_tab_lot" :class="addr_view_type=='jibun'?'result_tab_select':''" href="#"
             @click="setAddressViewType('jibun')"
             v-if="address_list!=null && address_list.length>0" aria-label="지번주소로 보기">지번주소</a>
          <a class="result_tab_road" :class="addr_view_type=='road'?'result_tab_select':''" href="#"
             @click="setAddressViewType('road')" v-if="address_list!=null && address_list.length>0"
             aria-label="도로명주소로 보기">도로명주소</a>
          <ul v-if="address_list==null || address_list.length==0">
            <li v-show="address_list==null" class="popup_result_none">{{ popup_title }}를 검색해주세요.
            </li>
            <li v-show="address_list!=null && address_list.length==0" class="popup_result_none">검색된
              주소 정보가 없습니다.
            </li>
          </ul>
          <ul v-if="address_list!=null && address_list.length>0">
            <li v-show="addr_view_type=='jibun'" v-for="(address, index) in address_list"
                :key="index+'_jibun'"><span aria-hidden="true"><a href="#">{{
                address.jibunAddr
              }}</a></span>
              <button class="btn_common" @click="getAddressLocation(address)"
                      :aria-label="`선택, ${address.jibunAddr}`">선택
              </button>
            </li>
            <li v-show="addr_view_type=='road'" v-for="(address, index) in address_list"
                :key="index+'_road'"><span aria-hidden="true"><a href="#">{{ address.roadAddr }}</a></span>
              <button class="btn_common" @click="getAddressLocation(address)"
                      :aria-label="`선택, ${address.roadAddr}`">선택
              </button>
            </li>
          </ul>
          <div class="btn_both" v-if="address_list!=null && address_list.length>0">
            <button class="btn_common btn_twin" @click="prevAddressList" v-show="curr_page > 1">이전
            </button>
            <button class="btn_common btn_twin" @click="nextAddressList"
                    v-show="curr_page < total_page">다음
            </button>
          </div>
        </div>
        <div class="popup_result" v-if="view_type=='history'">
          <h5>조회 결과</h5>
          <ul v-if="history_address_list==null || history_address_list.length==0">
            <li v-show="history_address_list==null" class="popup_result_none">{{ popup_title }}를
              검색해주세요.
            </li>
            <li v-show="history_address_list!=null && history_address_list.length==0"
                class="popup_result_none">최근 {{ popup_title }} 정보가 없습니다.
            </li>
          </ul>
          <!--  최근 출발 도착지-->
          <ul v-if="history_address_list!=null && history_address_list.length>0">
            <li v-show="addr_type=='s_addr'" v-for="(address, index) in history_address_list"
                :key="index+'_s_addr'"><span><a href="#" :aria-label="`버튼, ${address.nm_frsido} ${address.nm_frgugun} ${address.nm_frdong} ${address.nm_fr}`"  @click="setHistoryAddressInfo(address)">{{ address.nm_frsido
              }} {{ address.nm_frgugun }} {{ address.nm_frdong }} {{ address.nm_fr }}</a></span>
              <button class="btn_common btn_bm" :class="{btn_book : address.bookMark =='Y' }"
                      @click="setBookMark(address, 1)" v-if="address.bookMark != 'Y'"> 선택
              </button>
              <button class="btn_common btn_bm" :class="{btn_book : address.bookMark =='Y' }"
                      @click="setBookMark(address, 1)" v-if="address.bookMark == 'Y'">해제
              </button>
            </li>
            <li v-show="addr_type=='e_addr'" v-for="(address, index) in history_address_list"
                :key="index+'_e_addr'"><span><a href="#" :aria-label="`버튼, ${address.nm_tosido} ${address.nm_togugun} ${address.nm_todong} ${address.nm_to}`"
                                                @click="setHistoryAddressInfo(address)">{{address.nm_tosido}} {{ address.nm_togugun }} {{ address.nm_todong }} {{ address.nm_to }}</a></span>
              <button class="btn_common btn_bm" :class="{btn_book : address.bookMark =='Y' }"
                      @click="setBookMark(address, 2)" v-if="address.bookMark != 'Y'"> 선택
              </button>
              <button class="btn_common btn_bm" :class="{btn_book : address.bookMark =='Y' }"
                      @click="setBookMark(address, 2)" v-if="address.bookMark == 'Y'">해제
              </button>
            </li>
          </ul>
        </div>
        <div class="popup_result_bottom" v-if="view_type=='search'">
          <table class="table table-bordered result_table">
            <caption>주소 확인</caption>
            <thead></thead>
            <tbody>
            <tr>
              <th scope="row">기본주소</th>
              <td>{{ address.addr }}</td>
            </tr>
            <tr>
              <th scope="row"><label for="address_full">상세주소</label></th>
              <td><input type="text" class="form-control" ref="detail_add" id="detail_add"
                         placeholder="상세주소입력" v-model.trim="address.detail_add"/></td>
            </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
        <div class="btn_both" v-if="view_type=='search'">
          <button class="btn_common btn_twin" @click="setAddressInfo">확인</button>
          <button class="btn_common btn_twin" @click="addressPopupCloseInDialog">닫기</button>
        </div>
        <div class="popup_footer" v-if="view_type=='history'">
          <button class="btn_common" @click="addressPopupCloseInDialog">닫기</button>
        </div>
      </div>
    </transition>
    <div class="popup_layer" v-if="isPopup"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isPopup: false,
      addr_type: "",              /* s_addr:출발지, e_addr:도착지 */
      view_type: "search",        /* search:검색, history:최근 출발지/도착지 */
      addr_view_type: 'road',    /* jibun:지번, road:도로명 */
      popup_title: "",
      keyword: "",
      curr_page: 1,
      total_page: 0,
      total_address_list: null,  /* 주소검색 결과 전체 리스트 */
      address_list: null,         /* 주소검색 필터링 리트스*/
      history_address_list: null, /* 최근 출발지/도착지 결과 리스트 */
      bmCnt: 0,
      address: {
        addr: "",
        sido: "",
        gugun: "",
        dong: "",
        detail: "",
        detail_add: "",
        x: "",
        y: ""
      }
    }
  },
  methods: {
    trapFocus(event) {
      if (!this.isPopup) return;

      const focusableElements = Array.from(
          this.$el.querySelectorAll(
              'a, button, input[type="text"], textarea, select' // 다이얼로그 내에서 포커스 가능한 요소
          )
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.key === "Tab") {
        if (event.shiftKey) {
          // Shift + Tab (포커스를 역방향으로 이동)
          if (document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab (포커스를 순방향으로 이동)
          if (document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }

      if (event.key === "Escape") {
        // ESC 키로 다이얼로그 닫기
        this.addressPopupCloseInDialog();
      }
    },
    addressPopupShow(addr_type) {
      this.addr_type = addr_type;
      this.view_type = "search";
      this.addr_view_type = 'road';

      if (this.addr_type == 's_addr') {
        this.popup_title = "출발지";
      } else if(this.addr_type == 'e_addr') {
        this.popup_title = "도착지";
      } else if(this.addr_type == 'via_addr') {
        this.popup_title = "경유지";
      }

      this.isPopup = true;

      // this.$nextTick(() => {
      //   const focusTarget = this.addr_type === 's_addr'
      //       ? this.$refs.current_loc_sch
      //       : this.$refs.history_loc_sch;
      //
      //   if (focusTarget) focusTarget.focus();
      // });

      var self = this;

      if (this.addr_type == 's_addr') {
        setTimeout(
            function () {
              self.$refs.current_loc_sch.focus()
            },
            520
        );
      } else {
        setTimeout(
            function () {
              self.$refs.history_loc_sch.focus()
            },
            520
        );
      }
    },
    addressPopupCloseInDialog() {
      this.isPopup = false;
      this.keyword = "";
      this.curr_page = 1;
      this.total_page = 0;
      this.address_list = null;
      this.history_address_list = null;
      this.address = {
        addr: "",
        sido: "",
        gugun: "",
        dong: "",
        detail: "",
        x: "",
        y: ""
      };

      this.$emit('closePopup');
    },
    addressSearchShow() {
      this.curr_page = 1;
      this.addressSearch();
    },
    addressSearch() {
      if (this.keyword == "") {
        alert("주소정보를 입력해 주세요.");
        this.$refs.keyword.focus();
        return;
      }

      this.view_type = 'search';

      this.$jsonp(this.CONSTANT.ADDRESS_API_URL,
          {
            keyword: this.keyword,
            currentPage: this.curr_page,
            countPerPage: 100,
            resultType: 'json',
            confmKey: this.CONSTANT.ADDRESS_API_KEY
          }
      ).then(response => {
        if (response.results.common.errorCode != "0") {
          alert("주소 조회를 실패하였습니다.");
        } else {
          const jusoList = response.results.juso;

          this.curr_page = 1;
          this.total_page = Math.ceil(jusoList.length / 5);

          this.total_address_list = jusoList;
          this.updateAddressList();

          const totalCount = jusoList.length;
          this.updateSearchResultMessage(totalCount);

        }
      }).catch(err => {
        alert("주소 조회를 실패하였습니다.");
      });
    },

    updateSearchResultMessage(totalCount) {
      // 메시지 생성 및 업데이트
      const message = totalCount > 0
          ? `주소 검색이 완료되었습니다. 총 ${totalCount}건이 조회되었습니다.`
          : "검색된 주소 정보가 없습니다.";
      this.$refs.searchResultMessage.textContent = message;
    },
    setAddressViewType(type) {
      this.addr_view_type = type;
    },
    prevAddressList() {
      if (this.curr_page > 1) {
        this.curr_page--;
        this.updateAddressList();
      }
    },
    nextAddressList() {
      if (this.curr_page < this.total_page) {
        this.curr_page++;
        this.updateAddressList();
      }
    },
    updateAddressList() {
      const startIndex = (this.curr_page - 1) * 5;
      const endIndex = startIndex + 5;
      this.address_list = this.total_address_list.slice(startIndex, endIndex);
    },
    getAddressLocation(address) {
      this.$http.get("/api/order/addressSearch.do", {
        params: {
          address: address.jibunAddr
        }
      }).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          if (response.data.documents.length > 0) {

            //TODO: 2022년 주소 제대로 안나오는 현상 수정
            var addrInfo = response.data.documents[response.data.documents.length - 1];
            var detail = "";

            if (this.addr_view_type == 'jibun') {
              // 산 여부
              if (addrInfo.address.mountain_yn == "Y") {
                detail = "산";
              }

              // 지번 본번
              if (addrInfo.address.main_address_no != "") {
                detail += " " + addrInfo.address.main_address_no;
              }

              // 지번 부번
              if (addrInfo.address.sub_address_no != "") {
                detail += "-" + addrInfo.address.sub_address_no;
              }

              this.address.addr = addrInfo.address.address_name;
              this.address.sido = addrInfo.address.region_1depth_name;
              this.address.gugun = addrInfo.address.region_2depth_name;
              this.address.dong = addrInfo.address.region_3depth_name;
              this.address.detail = detail;
            } else {
              detail = addrInfo.road_address.road_name;

              // 지하 여부
              if (addrInfo.road_address.underground_yn == "Y") {
                detail += " 지하";
              }

              // 건물 본번
              if (addrInfo.road_address.main_building_no != "") {
                detail += " " + addrInfo.road_address.main_building_no;
              }

              // 건물 부번
              if (addrInfo.road_address.sub_building_no != "") {
                detail += "-" + addrInfo.road_address.sub_building_no;
              }

              this.address.addr = addrInfo.road_address.address_name;
              this.address.sido = addrInfo.road_address.region_1depth_name;
              this.address.gugun = addrInfo.road_address.region_2depth_name;
              this.address.dong = addrInfo.road_address.region_3depth_name;
              this.address.detail = detail;
            }

            this.address.x = addrInfo.x;
            this.address.y = addrInfo.y;

            if (address.bdNm != "") {
              this.address.detail_add = address.bdNm;
            } else {
              this.address.detail_add = "";
            }

            this.$refs.detail_add.focus();
            location.href = "#detail_add";
          } else {
            alert("주소 위치 검색을 실패하였습니다.");
          }
        } else {
          alert("주소 위치 검색을 실패하였습니다.");
        }
      });
    },
    getCurrentGeolocation() {
      console.log("call geo");

      if ("geolocation" in navigator) {
        console.log(navigator.geolocation);

        var self = this;
        navigator.geolocation.getCurrentPosition(function (position) {
          self.$http.get("/api/order/posAddressInfo.do", {
            params: {
              pos_lat: position.coords.latitude,
              pos_lng: position.coords.longitude
            }
          }).then((result) => {
            if (result.data.retval == self.CONSTANT.SUCCESS) {
              self.keyword = result.data.documents[result.data.documents.length - 1].address_name;
              self.addressSearch();
            } else {
              alert("현재 위치 검색을 실패하였습니다.");
            }
          });
        });
      } else {
        alert("위치 정보 획득을 실패하였습니다.");
      }
    },
    /* 현재 위치 주소 가져오기
    getCurrentGeolocation2() {
        if("geolocation" in navigator) {
            var self = this;
            navigator.geolocation.getCurrentPosition(function(position) {
                self.$http.get("/api/order/posAddressDetail.do", {
                    params: {
                        pos_lat: position.coords.latitude,
                        pos_lng: position.coords.longitude
                    }
                }).then((response) => {
                    if(response.data.retval == self.CONSTANT.SUCCESS) {
                        if(response.data.meta.total_count > 0) {
                            var addrInfo = response.data.documents[0];
                            var detail = addrInfo.road_address.road_name;

                            // 지하 여부
                            if(addrInfo.road_address.underground_yn == "Y") {
                                detail += " 지하";
                            }

                            // 건물 본번
                            if(addrInfo.road_address.main_building_no != "") {
                                detail += " "+addrInfo.road_address.main_building_no;
                            }

                            // 건물 부번
                            if(addrInfo.road_address.sub_building_no != "") {
                                detail += "-"+addrInfo.road_address.sub_building_no;
                            }

                            self.address.addr = addrInfo.road_address.address_name;
                            self.address.sido = addrInfo.road_address.region_1depth_name;
                            self.address.gugun = addrInfo.road_address.region_2depth_name;
                            self.address.dong = addrInfo.address.region_3depth_name;
                            self.address.detail = detail;

                            self.address.x = position.coords.longitude; //'127.0039099';
                            self.address.y = position.coords.latitude;  //'37.4832414';

                            if(addrInfo.road_address.building_name != "") {
                                self.address.detail_add = addrInfo.road_address.building_name;
                            } else {
                                self.address.detail_add = "";
                            }

                            self.$refs.detail_add.focus();
                            location.href = "#detail_add";
                        } else {
                            alert("현재 위치 검색을 실패하였습니다.");
                        }
                    } else {
                        alert("현재 위치 검색을 실패하였습니다. [error_code:"+response.data.retval+"]");
                    }
                });
            });
        } else {
            alert("위치 정보 획득을 실패하였습니다.");
        }
    },*/
    getAddrHistory() {
      this.view_type = 'history';

      let tmpKind = "1";
      if (this.addr_type == 's_addr') {
        tmpKind = 1;
      } else {
        tmpKind = 4;
      }

      this.$http.get("/api/order/callList.do", {
        params: {
          //kind: this.CONSTANT.CALL_SEARCH_TYPE_ADDRESS
          kind: tmpKind
        }
      }).then((response) => {
        if (response.data.retval == this.CONSTANT.SUCCESS) {
          this.history_address_list = response.data.list;
          this.bmCnt = 0;
          for (let i = 0; i < this.history_address_list.length; i++) {
            if (this.history_address_list[i].bookMark == 'Y') {
              this.bmCnt++;
            }
          }
        } else {
          if (response.data.retval == this.CONSTANT.LOGIN_ERROR) {
            this.$store.commit("setSession", null);
            this.$router.push({path: "/m/login", query: {return_url: "/m/order/call"}});
          } else {
            alert("최근 " + this.popup_title + " 검색을 실패 하였습니다. [error_code:" + response.data.retval
                + "]");
          }
        }
      });
    },
    setBookMark(addr, type) {
      var formData = new FormData();
      let tmpKind = "1";
      if (this.addr_type == 's_addr') {
        tmpKind = 1;
      } else {
        tmpKind = 4;
      }

      //formData.append("kind",this.CONSTANT.CALL_SEARCH_TYPE_ADDRESS);
      formData.append("kind", tmpKind);
      formData.append("bm_seq", addr.bm_seq);
      formData.append("nm_frsido", addr.nm_frsido);
      formData.append("nm_frgugun", addr.nm_frgugun);
      formData.append("nm_frdong", addr.nm_frdong);
      formData.append("nm_fr", addr.nm_fr);
      formData.append("no_frX", addr.no_frX);
      formData.append("no_frY", addr.no_frY);
      formData.append("nm_tosido", addr.nm_tosido);
      formData.append("nm_togugun", addr.nm_togugun);
      formData.append("nm_todong", addr.nm_todong);
      formData.append("nm_to", addr.nm_to);
      formData.append("no_toX", addr.no_toX);
      formData.append("no_toY", addr.no_toY);

      if (addr.bookMark != "Y") {
        if (this.bmCnt < 3) {
          const s_addr = `${addr.nm_frsido} ${addr.nm_frgugun} ${addr.nm_frdong} ${addr.nm_fr}`;
          const e_addr = `${addr.nm_tosido} ${addr.nm_togugun} ${addr.nm_todong} ${addr.nm_to}`;
          if (type === 1) {
            if (!confirm(`아래 주소를 즐겨찾기에서 등록하시겠습니까? \n ${s_addr}`)) {
              return;
            }
          } else {
            if (!confirm(`아래 주소를 즐겨찾기에서 등록하시겠습니까? \n ${e_addr}`)) {
              return;
            }
          }

          formData.append("action", "in");
          this.$http.post("/api/order/addBookMark.do", formData)
          .then((response) => {
            if (response.data.retval == this.CONSTANT.SUCCESS) {
              alert("즐겨찾기 등록완료 되었습니다.\n즐겨찾기는 상단 고정 됩니다.");
              this.getAddrHistory();
            } else {
              if (response.data.retval == this.CONSTANT.LOGIN_ERROR) {
                this.$store.commit("setSession", null);
                this.$router.push({path: "/m/login", query: {return_url: "/m/order/call"}});
              } else {
                alert("즐겨찾기 추가를 실패 하였습니다. [error_code:" + response.data.retval + "]");
              }
            }
          });

        } else {
          alert("즐겨찾기 등록이 초과 되었습니다.\n먼저 등록한 즐겨찾기를 해제하세요.");
        }
      } else {
        const s_addr = `${addr.nm_frsido} ${addr.nm_frgugun} ${addr.nm_frdong} ${addr.nm_fr}`;
        const e_addr = `${addr.nm_tosido} ${addr.nm_togugun} ${addr.nm_todong} ${addr.nm_to}`;
        if (type === 1) {
          if (!confirm(`아래 주소를 즐겨찾기에서 등록해제하시겠습니까? \n ${s_addr}`)) {
            return;
          }
        } else {
          if (!confirm(`아래 주소를 즐겨찾기에서 등록해제하시겠습니까? \n ${e_addr}`)) {
            return;
          }
        }

        formData.append("action", "out");
        this.$http.post("/api/order/addBookMark.do", formData)
        .then((response) => {
          if (response.data.retval == this.CONSTANT.SUCCESS) {
            alert("즐겨찾기 등록해제 되었습니다.");
            this.getAddrHistory();
          } else {
            if (response.data.retval == this.CONSTANT.LOGIN_ERROR) {
              this.$store.commit("setSession", null);
              this.$router.push({path: "/m/login", query: {return_url: "/m/order/call"}});
            } else {
              alert("즐겨찾기 해제를 실패 하였습니다. [error_code:" + response.data.retval + "]");
            }
          }
        });

      }

    },
    setAddressInfo() {
      if (this.view_type == "search") {
        if (this.address.detail_add != "") {
          this.address.detail = this.address.detail + " " + this.address.detail_add;
        }
      }

      this.$emit('setAddressInfo', this.addr_type, this.address);
      console.log("!!!addressPopupClose!!!")
      this.addressPopupCloseInDialog();
    },
    setHistoryAddressInfo(address) {
      if (this.addr_type == 's_addr') {
        this.address.addr = address.nm_frsido + " " + address.nm_frgugun + " " + address.nm_frdong
            + " " + address.nm_fr;
        this.address.sido = address.nm_frsido;
        this.address.gugun = address.nm_frgugun;
        this.address.dong = address.nm_frdong;
        this.address.detail = address.nm_fr;
        this.address.x = address.no_frX;
        this.address.y = address.no_frY;
      } else {
        this.address.addr = address.nm_tosido + " " + address.nm_togugun + " " + address.nm_todong
            + " " + address.nm_to;
        this.address.sido = address.nm_tosido;
        this.address.gugun = address.nm_togugun;
        this.address.dong = address.nm_todong;
        this.address.detail = address.nm_to;
        this.address.x = address.no_toX;
        this.address.y = address.no_toY;
      }

      this.setAddressInfo();
    }
  },
  mounted() {
    document.addEventListener("keydown", this.trapFocus); // 키보드 포커스 제어
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.trapFocus); // 이벤트 해제
  },
}
</script>

<style>
.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  100% {
    opacity: 1;
  }
}

.popup_result ul {
  max-height: 265px;
  overflow-y: auto;
}

.btn_book {
  background-color: red !important
}

.display-none {
  display: none;
}

.btn_both_triplet {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

</style>


// WEBPACK FOOTER //
// src/pages/order/Address.vue